import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_TEAMS,
  POST_TEAM,
} from "./actionTypes";

//Include Both Helper File with needed methods

import {
  getTeamsSuccess,
  getTeamsFail,
  postTeamFail,
} from "./actions";

import {
  getTeams,
  postAddTeam
} from "../../helpers/fakebackend_helper";

function* onGetTeams() {
  try {
    const response = yield call(getTeams);
    yield put(getTeamsSuccess(response));
  } catch (error) {
    yield put(postTeamFail(error));
  }
}

function* onPostAddTeam({ payload: { team, history } }) {
  const response = yield call(postAddTeam, {
    name: team.name
  })
  history('/teams');
}

function* teamSaga() {
  yield takeEvery(GET_TEAMS, onGetTeams);
  yield takeEvery(POST_TEAM, onPostAddTeam);
}

export default teamSaga;
